import { ENVELOPE_STATUS_FILTERS } from '@/api/v1/ecm/envelopes'
import { envelopesStatusPath } from '@/lib/envelopes-path'

import locales from './locales'

export { locales as pageTitleLocales }

/**
 * Map of paths to translation keys for page titles.
 *
 * For routes with sub-routes (settings, reports), the specific layout
 * is responsible for updating the title with more details.
 */
export const PAGE_TITLE_KEYS: Record<string, string> = {
  '/': 'dashboard',
  '/contacts': 'contacts',
  '/envelopes': 'envelopes',
  ...Object.fromEntries(
    ENVELOPE_STATUS_FILTERS.map((status) => [
      envelopesStatusPath(status),
      'envelopes',
    ]),
  ),
  '/envelopes/*': 'envelopeDetails',
  '/envelope': 'newEnvelope',
  '/envelope/*': 'editEnvelope',
  '/templates': 'templates',
  '/templates/*': 'templateDetails',
  '/template': 'newTemplate',
  '/template/*': 'editTemplate',
  '/vaults': 'vaults',
  '/vaults/*': 'vaultDetails',
  '/reports': 'reports',
  '/settings': 'settings',
  '/login': 'login',
  '/register': 'register',
  '/forgot-password': 'forgotPassword',
  '/switch': 'switchAccount',
  '/review/bulk/*': 'bulkSign',
  '/review': 'review',
  '/view': 'viewEnvelope',
  '/verify': 'verifyDocument',
  '/unsubscribe': 'unsubscribe',
  '/sign-mark': 'signMark',
  '/selfie': 'selfie',
}

/**
 * Finds the title key for a pathname.
 * Looks for exact match first, then partial match.
 */
export function findPageTitleKey(pathname: string): string | undefined {
  // Look for exact match first
  if (PAGE_TITLE_KEYS[pathname]) {
    return PAGE_TITLE_KEYS[pathname]
  }

  // Look for wildcard match (e.g., '/envelope/*' matches '/envelope/123')
  for (const [path, key] of Object.entries(PAGE_TITLE_KEYS)) {
    if (path.endsWith('/*') && pathname.startsWith(path.slice(0, -1))) {
      return key
    }
  }

  // Fallback to partial match (for routes like /review/abc)
  for (const [path, key] of Object.entries(PAGE_TITLE_KEYS)) {
    if (!path.endsWith('/*') && pathname.startsWith(path + '/')) {
      return key
    }
  }

  return undefined
}
